import { render, staticRenderFns } from "./BonusesPrint.vue?vue&type=template&id=5efcc9a5&scoped=true"
import script from "./BonusesPrint.vue?vue&type=script&lang=js"
export * from "./BonusesPrint.vue?vue&type=script&lang=js"
import style0 from "./BonusesPrint.vue?vue&type=style&index=0&id=5efcc9a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcc9a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
